import { defaultMaxTime, defaultMinTime } from "../constants/times";
import { isNumeric } from "./number";

type DeliveryWindowSource = {
    order_from?: string | null;
    order_to?: string | null;
};

type AdvanceSource = {
    order_in_advance?: string | number | null;
};

export const getDeliveryWindow = (product: DeliveryWindowSource) => {
    const min = product.order_from && product.order_from !== "" ? product.order_from : defaultMinTime;
    const max = product.order_to && product.order_to !== "" ? product.order_to : defaultMaxTime;
    return { min, max };
};

export const getAdvanceDays = (product: AdvanceSource, fallback: number = 1) => {
    if (typeof product.order_in_advance === "number") {
        return product.order_in_advance;
    }
    const token = String(product.order_in_advance ?? "").trim().split(/\s+/)[0];
    return isNumeric(token) ? Number(token) : fallback;
};
